module.exports = __webpack_public_path__ + "img/ico-search-query.a7002eea.svg";